// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* обёртка модалки */
.ReceiptPage_modal__MhRzX {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.65);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
}

/* содержимое */
.ReceiptPage_content__Y8a\\+a {
  background: #fff;
  border-radius: 10px;
  width: 90%;
  max-width: 600px;
  height: 90vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
  animation: ReceiptPage_slideIn__3fSzm 0.3s ease-out;
}

/* HEADER */
.ReceiptPage_header__4wvt5 {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 60px;
  background: linear-gradient(135deg, #007bff, #00aaff);
  padding: 0 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  z-index: 10;
}

.ReceiptPage_titleWrapper__g7MOI {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.ReceiptPage_title__W181q {
  margin: 0;
  font-weight: 600;
  font-size: 24px;
  line-height: 1.2;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

/* BODY */
.ReceiptPage_body__qjSbt {
  position: absolute;
  top: 70px;
  bottom: 100px;
  left: 0;
  right: 0;
  padding: 0 10px;
  overflow-y: auto;
  background-color: #fdfdfd;
  font-family: sans-serif;
}

.ReceiptPage_row__Bt16w {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 6px 0;
  border-bottom: 1px solid #ddd;
}

.ReceiptPage_row__Bt16w:last-child {
  border-bottom: none;
}


 .ReceiptPage_text__ZwqdX {
  flex: 1 1;
  text-align: left;            /* прижимает текст к левому краю */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-left: 10px;

 }

/* Кнопка показать контакты */
.ReceiptPage_showContactsWrapper__xrSQL {
  margin: 1rem 0;
}

.ReceiptPage_showContactsButton__jFg4U {
  width: 100%;
  padding: 8px;
  background: #007bff;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.ReceiptPage_showContactsButton__jFg4U:hover {
  background: #0056b3;
}

/* Итоговая секция перед футером */
.ReceiptPage_totalSection__8w1JS {
  padding: 0 16px;
  font-weight: bold;
  text-align: right;
  margin-top: auto;
}

/* Закрыть */
.ReceiptPage_closeButton__aAtKi {
  background: #007bff;
  color: #fff;
  border: none;
  height: 50px;
  font-size: 1em;
  cursor: pointer;
  text-align: center;
}

.ReceiptPage_closeButton__aAtKi:hover {
  background: #0056b3;
}

/* вместо .product-card */
.ReceiptPage_productCard__E39aw {
  background: #f9f9f9;
  border-radius: 6px;
  padding: 3px;
  display: flex;
  flex-direction: column;
  box-shadow: 1px 1px 6px rgba(0, 0, 0, 0.1);
}

/* вместо .product-header */
.ReceiptPage_productHeader__hZu9p {
  font-weight: bold;
  font-size: 1em;
  color: #333;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/* вместо .product-info */
.ReceiptPage_productInfo__axHV7 {
  display: flex;
  flex-wrap: wrap;
  gap: 0px;
  justify-content: space-between;
}

/* вместо .product-field */
.ReceiptPage_productField__QFyYu {
  display: flex;
  align-items: center;
  gap: 0px;
  font-size: 0.9em;
  background: #fff;
  padding: 4px 6px;
  border-radius: 4px;
  border: 1px solid #ddd;
}


/* Анимация */
@keyframes ReceiptPage_slideIn__3fSzm {
  from { transform: translateY(-20px); opacity: 0; }
  to   { transform: translateY(  0); opacity: 1; }
}

.ReceiptPage_checkAction__ukRcu {
  position: absolute;
  width: 100%;
  bottom: 60px;
  display: flex;
  justify-content: center;
  gap: 10px;
}

.ReceiptPage_checkButton__SABrT {
  padding: 10px 20px;
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 4px;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.2s;
  z-index: 100;
}

.ReceiptPage_notdeliveredButton__PIhrJ {
  padding: 10px 20px;
  background-color: #ff0000;
  color: #fff;
  border: none;
  border-radius: 4px;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.2s;
  z-index: 100;
}

.ReceiptPage_checkButton__SABrT:hover {
  background-color: #0056b3;
}
`, "",{"version":3,"sources":["webpack://./src/modules/Courier/CourierModal/styles/ReceiptPage.module.css"],"names":[],"mappings":"AAAA,oBAAoB;AACpB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA,eAAe;AACf;EACE,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,mDAAgC;AAClC;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,qDAAqD;EACrD,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA,SAAS;AACT;EACE,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,OAAO;EACP,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;;CAGC;EACC,SAAO;EACP,gBAAgB,aAAa,kCAAkC;EAC/D,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;;CAEnB;;AAED,6BAA6B;AAC7B;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,kCAAkC;AAClC;EACE,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA,2BAA2B;AAC3B;EACE,iBAAiB;EACjB,cAAc;EACd,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,8BAA8B;AAChC;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;;AAGA,aAAa;AACb;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,OAAO,0BAA0B,EAAE,UAAU,EAAE;AACjD;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;EACjC,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;EACjC,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["/* обёртка модалки */\r\n.modal {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  background: rgba(0, 0, 0, 0.65);\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  z-index: 2000;\r\n}\r\n\r\n/* содержимое */\r\n.content {\r\n  background: #fff;\r\n  border-radius: 10px;\r\n  width: 90%;\r\n  max-width: 600px;\r\n  height: 90vh;\r\n  display: flex;\r\n  flex-direction: column;\r\n  overflow: hidden;\r\n  position: relative;\r\n  animation: slideIn 0.3s ease-out;\r\n}\r\n\r\n/* HEADER */\r\n.header {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  height: 60px;\r\n  background: linear-gradient(135deg, #007bff, #00aaff);\r\n  padding: 0 16px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  color: #fff;\r\n  z-index: 10;\r\n}\r\n\r\n.titleWrapper {\r\n  width: 100%;\r\n  height: 100%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  overflow: hidden;\r\n}\r\n\r\n.title {\r\n  margin: 0;\r\n  font-weight: 600;\r\n  font-size: 24px;\r\n  line-height: 1.2;\r\n  white-space: nowrap;\r\n  text-overflow: ellipsis;\r\n  overflow: hidden;\r\n}\r\n\r\n/* BODY */\r\n.body {\r\n  position: absolute;\r\n  top: 70px;\r\n  bottom: 100px;\r\n  left: 0;\r\n  right: 0;\r\n  padding: 0 10px;\r\n  overflow-y: auto;\r\n  background-color: #fdfdfd;\r\n  font-family: sans-serif;\r\n}\r\n\r\n.row {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: flex-start;\r\n  padding: 6px 0;\r\n  border-bottom: 1px solid #ddd;\r\n}\r\n\r\n.row:last-child {\r\n  border-bottom: none;\r\n}\r\n\r\n\r\n .text {\r\n  flex: 1;\r\n  text-align: left;            /* прижимает текст к левому краю */\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  padding-left: 10px;\r\n\r\n }\r\n\r\n/* Кнопка показать контакты */\r\n.showContactsWrapper {\r\n  margin: 1rem 0;\r\n}\r\n\r\n.showContactsButton {\r\n  width: 100%;\r\n  padding: 8px;\r\n  background: #007bff;\r\n  color: #fff;\r\n  border: none;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n}\r\n\r\n.showContactsButton:hover {\r\n  background: #0056b3;\r\n}\r\n\r\n/* Итоговая секция перед футером */\r\n.totalSection {\r\n  padding: 0 16px;\r\n  font-weight: bold;\r\n  text-align: right;\r\n  margin-top: auto;\r\n}\r\n\r\n/* Закрыть */\r\n.closeButton {\r\n  background: #007bff;\r\n  color: #fff;\r\n  border: none;\r\n  height: 50px;\r\n  font-size: 1em;\r\n  cursor: pointer;\r\n  text-align: center;\r\n}\r\n\r\n.closeButton:hover {\r\n  background: #0056b3;\r\n}\r\n\r\n/* вместо .product-card */\r\n.productCard {\r\n  background: #f9f9f9;\r\n  border-radius: 6px;\r\n  padding: 3px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  box-shadow: 1px 1px 6px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n/* вместо .product-header */\r\n.productHeader {\r\n  font-weight: bold;\r\n  font-size: 1em;\r\n  color: #333;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n\r\n/* вместо .product-info */\r\n.productInfo {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 0px;\r\n  justify-content: space-between;\r\n}\r\n\r\n/* вместо .product-field */\r\n.productField {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0px;\r\n  font-size: 0.9em;\r\n  background: #fff;\r\n  padding: 4px 6px;\r\n  border-radius: 4px;\r\n  border: 1px solid #ddd;\r\n}\r\n\r\n\r\n/* Анимация */\r\n@keyframes slideIn {\r\n  from { transform: translateY(-20px); opacity: 0; }\r\n  to   { transform: translateY(  0); opacity: 1; }\r\n}\r\n\r\n.checkAction {\r\n  position: absolute;\r\n  width: 100%;\r\n  bottom: 60px;\r\n  display: flex;\r\n  justify-content: center;\r\n  gap: 10px;\r\n}\r\n\r\n.checkButton {\r\n  padding: 10px 20px;\r\n  background-color: #007bff;\r\n  color: #fff;\r\n  border: none;\r\n  border-radius: 4px;\r\n  font-size: 1rem;\r\n  cursor: pointer;\r\n  transition: background-color 0.2s;\r\n  z-index: 100;\r\n}\r\n\r\n.notdeliveredButton {\r\n  padding: 10px 20px;\r\n  background-color: #ff0000;\r\n  color: #fff;\r\n  border: none;\r\n  border-radius: 4px;\r\n  font-size: 1rem;\r\n  cursor: pointer;\r\n  transition: background-color 0.2s;\r\n  z-index: 100;\r\n}\r\n\r\n.checkButton:hover {\r\n  background-color: #0056b3;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `ReceiptPage_modal__MhRzX`,
	"content": `ReceiptPage_content__Y8a+a`,
	"slideIn": `ReceiptPage_slideIn__3fSzm`,
	"header": `ReceiptPage_header__4wvt5`,
	"titleWrapper": `ReceiptPage_titleWrapper__g7MOI`,
	"title": `ReceiptPage_title__W181q`,
	"body": `ReceiptPage_body__qjSbt`,
	"row": `ReceiptPage_row__Bt16w`,
	"text": `ReceiptPage_text__ZwqdX`,
	"showContactsWrapper": `ReceiptPage_showContactsWrapper__xrSQL`,
	"showContactsButton": `ReceiptPage_showContactsButton__jFg4U`,
	"totalSection": `ReceiptPage_totalSection__8w1JS`,
	"closeButton": `ReceiptPage_closeButton__aAtKi`,
	"productCard": `ReceiptPage_productCard__E39aw`,
	"productHeader": `ReceiptPage_productHeader__hZu9p`,
	"productInfo": `ReceiptPage_productInfo__axHV7`,
	"productField": `ReceiptPage_productField__QFyYu`,
	"checkAction": `ReceiptPage_checkAction__ukRcu`,
	"checkButton": `ReceiptPage_checkButton__SABrT`,
	"notdeliveredButton": `ReceiptPage_notdeliveredButton__PIhrJ`
};
export default ___CSS_LOADER_EXPORT___;
